export  enum Constantes {
    AND = " AND ",
    OR = " OR ",
    NOT = " NOT ",
    DDMMYYYY = "DD/MM/YYYY",
    YYYYMMDD = "YYYY/MM/DD",
    PARENTESE = "("
}
export default Constantes;

